const { DEV, VITE_LOCAL } = import.meta.env

import { userService as local } from './user.service.local'
import { userService as remote } from './user.service.remote'

function getEmptyUser() {
  return {
    nickname: '', // שם המשתמש
    email: '', // דוא"ל
    password: '', // סיסמה
    usertag: 'משתמש רשום', // תגית משתמש
    image:
      'https://pub-60946b28fb374ff48942bac3163dd658.r2.dev/user-icon-default_olftzk.svg', // תמונה ברירת מחדל
    role: 'user', // תפקיד המשתמש
    comments: [], // תגובות שהמשתמש כתב
    posts: [], // פוסטים שהמשתמש כתב
  }
}

const service = VITE_LOCAL === 'true' ? local : remote
export const userService = { ...service, getEmptyUser }

// גישה קלה לשירות מה-console בזמן פיתוח
if (DEV) window.userService = userService
